import axios from 'axios'
import { MessageBox } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Loading } from 'element-ui'
import {REQUEST_HEADER} from '../config/config.js'

// 创建axios的实例
const request = axios.create({
  baseURL: '',
  timeout: 20000
})

// 设置各种请求的请求同头
request.interceptors.request.use(
  config => {
    NProgress.start();
    if(config.url !== "/ps/user/login"){
      openLoading();
    }
    if (config.method.toLocaleLowerCase() === 'post') {
      config.headers.post = {
        'Content-Type': 'application/json'
      }
    }
    if (config.method.toLocaleLowerCase() === 'put') {
      config.headers.put = {
        'Content-Type': 'application/json'
      }
    }
    if (config.method.toLocaleLowerCase() === 'delete') {
      config.headers.delete = {
        'Content-Type': 'application/json'
      }
    }
    config.headers['Authorization'] = REQUEST_HEADER.Authorization
    return config
  }
)
// 响应拦截
request.interceptors.response.use(
  response => {

    NProgress.done();
    endLoading();
    const res = response.data
    if (res.code !== '000000') {
      MessageBox.confirm(res.message, {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      })
      if(res.code === '001009'){
        MessageBox.confirm(res.message+'请重新登录!', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then( () => {
          this.$router.push({ path: "/" })
        })
      }
      return Promise.reject(new Error(res.message || 'error'))
    } else {
      return res
    }
  }
)
let loading;

function openLoading() {
  // loading = Loading.service({
  //   target: '.el-main',
  //   lock: true,
  //   text: "数据加载中",
  //   background: 'rgba(0, 0, 0, 0.3)',
  //   spinner: 'el-icon-loading'
  // })
}

function endLoading() {
  // loading.close();
}

export default request



// WEBPACK FOOTER //
// ./src/axios/axiosconfig.js